import { useNavigate } from "react-router-dom";
import { PortalSidebar, type SidebarNavSection } from "@/shared/layout/PortalSidebar";
import { SidebarProfileCard } from "@/shared/layout/SidebarProfileCard";
import { useAdminAuthStore } from "@/stores/adminAuthStore";

const navSections: SidebarNavSection[] = [
  {
    title: "Administration",
    items: [
      { path: "/admin",             label: "Dashboard",    icon: "lucide:layout-dashboard", end: true },
      { path: "/admin/users",       label: "Patients",     icon: "lucide:users"                      },
      { path: "/admin/audit-trail", label: "Audit Trail",  icon: "lucide:history"                    },
    ],
  },
];

function getInitials(name: string) {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return `${first}${last}`.toUpperCase();
}

function AdminProfileCard() {
  const admin = useAdminAuthStore((s) => s.user);
  return (
    <SidebarProfileCard
      avatarInitials={admin ? getInitials(admin.name) : "A"}
      avatarBg="bg-[#0A2947]"
      name="Admin"
      showChevron={false}
    />
  );
}

export function AdminSidebar() {
  const signOut = useAdminAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate("/admin/signin", { replace: true });
  };

  return (
    <PortalSidebar
      logoTitle="MedSyncIQ"
      logoSubtitle="Admin Portal"
      profileSlot={<AdminProfileCard />}
      navSections={navSections}
      onSignOut={handleSignOut}
    />
  );
}
